import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  raceItem: {
    display: "grid",
    padding: "9px 16px",
    gridTemplateColumns: "35px 1fr 60px 44px",
    alignItems: "center",
    fontSize: 12,
    borderTop: "1px solid #eeeeee",
    "&:nth-child(even)": {
      backgroundColor: "rgba(238, 238, 238, 0.25)"
    },
    textDecoration: "none",
    color: theme.palette.text.primary,
    "&.withSmallWidthIcon": {
      gridTemplateColumns: "35px 1fr 60px 35px"
    }
  },
  textCell: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  codeCell: {
    paddingRight: 12
  },
  boldText: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  linkIcon: {
    color: "rgba(97, 198, 158, 1)",
    fontSize: 15,
    justifySelf: "flex-end",
    position: "relative",
    bottom: 1
  }
}));
